import { ComponentType } from 'react';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { FullPageLoader } from '../../../components';
import { VerifyYourEmail } from '../../../pages/verify-email';

type ProtectedRouteType = {
  children: JSX.Element;
};

export const ProtectedRoute = ({ children }: ProtectedRouteType) => {
  const { isAuthenticated } = useAuth0();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};

export const AuthenticationGuard = ({ component }: { component: ComponentType }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <FullPageLoader />,
  });

  const { user } = useAuth0();

  if (user && !user.email_verified) {
    return <VerifyYourEmail />;
  }

  return <Component />;
};
